export default "__VITE_ASSET__285462bc__"